/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const StudentRow = ({
  student,
  reg,
  index,
  selectedRows,
  handleStudentSelection,
  filterOutStudents
}) => {
  const { t: tr } = useTranslation();
  const studentSelected = selectedRows[reg.id] ? selectedRows[reg.id][student.id] : false;
  let studentRowClass = "";

  if (filterOutStudents) {
    studentRowClass += " absent";
  } else if (studentSelected) {
    studentRowClass += " selected-row";
  } else if (index % 2 !== 0) {
    studentRowClass += " report-table-row-alternate";
  }

  return (
    <div
      className={`student report-table-row ${studentRowClass} row manage-text`}
    >
      <div className="col-sm report-expand ml-3 d-flex align-items-center">
        <div className="report-checkbox-small expand-button text-with-icon d-flex align-items-center justify-content-end mr-2">
          {!filterOutStudents && (
            <input
              type="checkbox"
              checked={selectedRows[reg.id] ? selectedRows[reg.id][student.id] : false}
              onChange={e => handleStudentSelection(
                reg.id,
                student.id,
                e.target.checked
              )}
            />
          )}
        </div>
      </div>
      <div className="col-sm report-date-col text-center" />
      <div className="col-sm report-weekday-col text-center" />
      <div className="col-sm report-start-time-col text-center" />
      <div className="col-sm report-lesson-type-col text-center" />
      <div className="col-sm report-student-col text-center" data-label={tr("manage:student_14")}>
        {student.studentName}
      </div>
      <div className="col-sm report-client-col text-center" data-label={tr("manage:client_108")}>
        {student.clientName || ""}
      </div>
      <div className="col-sm report-teacher-col text-center" />
      <div className="col-sm report-present-col text-center" data-label={tr("client:present_31")}>
        {student.isPresent ? "1" : "0"}/1
      </div>
      <div className="col-sm report-comment-col text-center" data-label={tr("manage:notes_10")}>
        {student.comment}
      </div>
    </div>
  );
};

StudentRow.propTypes = {
  student: PropTypes.shape({
    id: PropTypes.string.isRequired,
    studentName: PropTypes.string.isRequired,
    isPresent: PropTypes.bool.isRequired,
    comment: PropTypes.string.isRequired,
    clientName: PropTypes.string,
  }).isRequired,
  reg: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  selectedRows: PropTypes.object.isRequired,
  handleStudentSelection: PropTypes.func.isRequired,
  filterOutStudents: PropTypes.bool.isRequired,
};

export default StudentRow;
